module.exports = __webpack_public_path__ + "img/ercode.2450a29c.png";